import type { TChapterWithoutContent } from '../../types/fanfic';

/**
 * Sort without importing chapters-dnd (that module pulls @dnd-kit and breaks RSC).
 */
const sortChaptersByOrder = (chapters: TChapterWithoutContent[]): TChapterWithoutContent[] =>
  [...chapters].sort(
    (leftChapter, rightChapter) => (leftChapter.order ?? 0) - (rightChapter.order ?? 0),
  );

/**
 * Public work pages should only expose published chapters in SEO links.
 */
export const isPublishedChapter = (chapter: TChapterWithoutContent): boolean => {
  if (chapter.status === 'draft') {
    return false;
  }

  if (chapter.isPublished === false) {
    return false;
  }

  return true;
};

export const resolvePublishedChapters = (
  chapters: TChapterWithoutContent[],
): TChapterWithoutContent[] => sortChaptersByOrder(chapters.filter(isPublishedChapter));

export const resolveFirstPublishedChapter = (
  chapters: TChapterWithoutContent[],
): TChapterWithoutContent | undefined => resolvePublishedChapters(chapters)[0];
